import {
  getGiftCardsApi,
  purchaseGiftCardApi,
  getGiftCardSalesByAccountIdApi,
} from "@/global/api/giftCard";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { GiftCardType } from "@/global/store/data/types";
import { useMutation } from "@tanstack/react-query";

export function useGiftCardApis() {
  const { teamSchema } = useTeamConfig();
  const getGiftCards = useMutation(getGiftCardsApi);
  const checkoutGiftCard = useMutation(purchaseGiftCardApi);
  const getGiftCardSalesByAccountId = useMutation(getGiftCardSalesByAccountIdApi); // prettier-ignore

  const handleGetGiftCards = async (callback: (a: GiftCardType[]) => void) => {
    try {
      const payload = { teamSchema };
      await getGiftCards.mutateAsync(payload, {
        onSuccess: ({ data }) => {
          callback(data);
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  return {
    getGiftCards,
    handleGetGiftCards,
    checkoutGiftCard,
    getGiftCardSalesByAccountId,
  };
}
